import { SelectionInfo } from '../../word/types/wordTypes';
// import { log } from '../../utils/logging';

export class SelectionManager {
  private currentSelection: SelectionInfo | null = null;
  private listeners: ((selection: SelectionInfo | null) => void)[] = [];

  /**
   * Updates the current selection
   */
  setSelection(selection: SelectionInfo | null): void {
    this.currentSelection = selection;
    // log(`Selection updated: ${selection ? selection.text.substring(0, 50) + '...' : 'null'}`);
    this.notifyListeners();
  }

  /**
   * Gets the current selection
   */
  getSelection(): SelectionInfo | null {
    return this.currentSelection;
  }

  /**
   * Checks if there is a valid selection
   */
  hasSelection(): boolean {
    return this.currentSelection !== null && !this.currentSelection.isEmpty;
  }

  /**
   * Clears the current selection
   */
  clearSelection(): void {
    this.currentSelection = null;
    this.notifyListeners();
  }

  /**
   * Registers a listener for selection changes
   */
  onSelectionChange(listener: (selection: SelectionInfo | null) => void): () => void {
    this.listeners.push(listener);
    
    // Return unsubscribe function
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  private notifyListeners(): void {
    this.listeners.forEach((listener) => {
      try {
        listener(this.currentSelection);
      } catch (error) {
        console.error('Error in selection change listener', error);
      }
    });
  }
}

